import { translate } from "../../util/translate"

/**
 * Headers for the real estate's own branch screen. Not shared with realEstateBranchHeaders: that one pins
 * 1030px of fixed widths for the admin's full-width layout, which pushes the actions column out of view in
 * the narrower client layout. No widths here on purpose - the table then fits whatever container it gets,
 * and the address is clamped by CSS in the view so it cannot blow the layout up. CNPJ is an edit-form
 * detail, and the headquarter badge rides along with the name, so neither takes a column.
 */
export const branchHeaders = [
  {
    text: translate['customer.branches.label.name'],
    value: 'name',
  },
  {
    text: translate['customer.branches.label.city'],
    value: 'city',
  },
  {
    text: translate['customer.branches.label.address'],
    value: 'address',
  },
  {
    value: 'actions',
    align: 'end',
  },
]
